import  useSlidePanel from './useSlidePanel';
export default useSlidePanel
